//import React from 'react';
import {React, useEffect, useState, useRef, useLayoutEffect} from 'react';
import './App.css';
import Navbar from './components/navbar';
import { BrowserRouter as Router, Routes, Route }
	from 'react-router-dom';
//import Home from './pages';
import Home from './pages/index2';
import About from './pages/about';
import Admin from './pages/admin3';
import Contact from './pages/contact';
import Tree_Trimming from './pages/tree_trimming';
import Tree_Removal from './pages/tree_removal';
import Stump_Removal from './pages/stump_removal';
import Debris_Hauling from './pages/debris_hauling';
import Tree_Service_Sarasota from './pages/tree_service_sarasota';
import Tree_Service_StPete from './pages/tree_service_stpete';
import Tree_Service_Tampa from './pages/tree_service_tampa';
import Tree_Service_Bradenton from './pages/tree_service_bradenton';
import Tree_Service_Siesta_Key from './pages/tree_service_siesta_key';
import Tree_Service_Longboat_Key from './pages/tree_service_longboat_key';
import Tree_Service_Lakewood_Ranch from './pages/tree_service_lakewood_ranch';
import Tree_Service_Venice from './pages/tree_service_venice';
import Tree_Service_Palmetto from './pages/tree_service_palmetto';
import Tree_Service_North_Port from './pages/tree_service_north_port';
import Tree_Service_Osprey from './pages/tree_service_osprey';
import Tree_Service_Palmer_Ranch from './pages/tree_service_palmer_ranch';
import Tree_Service_Englewood from './pages/tree_service_englewood';
import Tree_Service_Punta_Gorda from './pages/tree_service_punta_gorda';
import Tree_Service_Ruskin from './pages/tree_service_ruskin';
import Tree_Service_Riverview from './pages/tree_service_riverview';
import Tree_Service_Pinellas_Park from './pages/tree_service_pinellas_park';
import Tree_Service_Parrish from './pages/tree_service_parrish';
import Blog from './pages/blog';
import TreeTrimmingSarasota from './pages/blog/TreeTrimmingSarasota';
import StumpGrindingGuide from './pages/blog/StumpGrindingGuide';
import HurricaneSeasonTreeCare from './pages/blog/HurricaneSeasonTreeCare';
import Reviews from './pages/reviews'
import { PiPhoneCallBold } from "react-icons/pi";
 import { FiCalendar } from "react-icons/fi";
 import UserModal from './pages/UserModal';

function App() {

	const [isModalOpen, setIsModalOpen] = useState(false);
	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	return (
		<Router>
			<Navbar />
			<Routes>
				<Route exact path='/' element={<Home />} />
				<Route path='/about' element={<About />} />
				<Route path='/contact' element={<Contact />} />
        		<Route path='/tree_trimming' element={<Tree_Trimming />} />
        		<Route path='/tree_removal' element={<Tree_Removal />} />
        		<Route path='/stump_removal' element={<Stump_Removal />} />
        		<Route path='/debris_hauling' element={<Debris_Hauling />} />
				<Route path='/tree_service_sarasota' element={<Tree_Service_Sarasota />} />
				<Route path='/tree_service_stpete' element={<Tree_Service_StPete />} />
				<Route path='/tree_service_tampa' element={<Tree_Service_Tampa />} />
				<Route path='/tree_service_bradenton' element={<Tree_Service_Bradenton />} />
				<Route path='/tree_service_siesta_key' element={<Tree_Service_Siesta_Key />} />
				<Route path='/tree_service_longboat_key' element={<Tree_Service_Longboat_Key />} />
				<Route path='/tree_service_lakewood_ranch' element={<Tree_Service_Lakewood_Ranch />} />
				<Route path='/tree_service_venice' element={<Tree_Service_Venice />} />
				<Route path='/tree_service_palmetto' element={<Tree_Service_Palmetto />} />
				<Route path='/tree_service_north_port' element={<Tree_Service_North_Port />} />
				<Route path='/tree_service_osprey' element={<Tree_Service_Osprey />} />
				<Route path='/tree_service_palmer_ranch' element={<Tree_Service_Palmer_Ranch />} />
				<Route path='/tree_service_englewood' element={<Tree_Service_Englewood />} />
				<Route path='/tree_service_punta_gorda' element={<Tree_Service_Punta_Gorda />} />
				<Route path='/tree_service_ruskin' element={<Tree_Service_Ruskin />} />
				<Route path='/tree_service_riverview' element={<Tree_Service_Riverview />} />
				<Route path='/tree_service_pinellas_park' element={<Tree_Service_Pinellas_Park />} />
				<Route path='/tree_service_parrish' element={<Tree_Service_Parrish />} />
				<Route path='/blog' element={<Blog />} />
				<Route path="/blog/tree-trimming-sarasota" element={<TreeTrimmingSarasota />}/>
				<Route path="/blog/stump-grinding-guide" element={<StumpGrindingGuide />} />
				<Route path="/blog/hurricane-season-tree-care" element={<HurricaneSeasonTreeCare />} />
        		<Route path='/reviews' element={<Reviews />} />
        		<Route path='/admin' element={<Admin />} />
			</Routes>
      <div className='contact_app' onClick={() => window.location.href = 'tel:941-879-8853'}>
        <div className='circle_icon_contact_app'><PiPhoneCallBold /></div>
      </div>

	  <div className='apt_app' onClick={(e) => {
    						e.preventDefault(); // Prevent the default link action
    						openModal();
  						}}>
        <div className='circle_icon_apt_app'><FiCalendar /></div>
      </div>
	    {isModalOpen && <UserModal onClose={closeModal} />}
		<UserModal isOpen={isModalOpen} onClose={closeModal} />
	  
		</Router>
	);
}

export default App;


